@if (sectionsData.length > 0 && showOnlyGridFlag) {
<article class="request-container">
  <div class="request-container__content">
    <ngx-masonry
      (layoutComplete)="reloadMasonryLayout()"
      [options]="{ fitWidth: true }"
      [ordered]="true"
      class="container-masonry"
    >
      @for (info of sectionsData; track info; let i = $index) {
      <div [attr.data-index]="i" class="request-container__item" ngxMasonryItem>
        <app-editable-card
          (reloadCardData)="reloadCardData()"
          [actions]="info.actions"
          [data]="info"
          [tab]="data.name"
        ></app-editable-card>
      </div>
      }
    </ngx-masonry>
  </div>
</article>
}
